// ----------------------------------------------------------------------------
// Snippet: Icon
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_icons.scss';

// TODO: Should we consider to include this snippet globally in app.js instead of include it in sections?